import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { ModalContainer, styles } from "./styles";
import { useGetCustomerPortalLink } from "../../hooks/useGetCustomerPortalLink";
import { MasteringBillingProps } from "./types";

export const MasteringBilling: React.FC<MasteringBillingProps> = ({
  handleMasterModalOpen,
  isMasterModalOpen,
  handleMasterModalClose,
}) => {
  const { getCustomerPortalLink } = useGetCustomerPortalLink();

  return (
    <>
      <Button onClick={handleMasterModalOpen}>Open modal</Button>
      <Modal
        open={isMasterModalOpen}
        onClose={handleMasterModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalContainer>
          <Box sx={styles.paymentDetailsContainer}>
            <Typography
              variant="h6"
              align="center"
              marginTop="10px"
              marginBottom="10px"
            >
              Enter a payment method to access our Dolby.io AI mastering
              feature.
            </Typography>
            <Typography variant="subtitle2" align="center" marginBottom="40px">
              Mastering a track is $3.99 per track for Minor users & $4.99 per
              track for Major users. Dolby AI mastering include unlimited
              30 second previews of presets. Seamlessly master your music to
              the audio specifications of your favorite streaming services / distributors.
            </Typography>
            <Box sx={styles.enterPaymentMethodButtonContainer}>
              <Button
                onClick={getCustomerPortalLink}
                variant="contained"
                sx={styles.enterPaymentMethodButton}
              >
                Enter Payment Method
              </Button>
              <Button
                onClick={handleMasterModalClose}
                variant="contained"
                sx={styles.dismissButton}
              >
                Dismiss
              </Button>
            </Box>
          </Box>
        </ModalContainer>
      </Modal>
    </>
  );
};
